var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      ref: "dialog",
      attrs: {
        color: "success",
        icon: "mdi-plus",
        title: "Ajouter un document",
        "store-modal": ""
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "mx-2",
                  attrs: {
                    small: "",
                    color: "success",
                    loading: _vm.isLoading,
                    disabled: !_vm.valid
                  },
                  on: { click: _vm.add }
                },
                [_vm._v("\n      Ajouter\n    ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mx-2",
                  attrs: { small: "" },
                  on: { click: _vm.close }
                },
                [_vm._v("\n      Annuler\n    ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "div",
        {
          staticStyle: { width: "65vw", "max-width": "800px", margin: "auto" }
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  label: "Titre *",
                  rules: [
                    text => text !== "" || "Vous devez renseigner un titre."
                  ]
                },
                model: {
                  value: _vm.title,
                  callback: function($$v) {
                    _vm.title = $$v
                  },
                  expression: "title"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  !_vm.action
                    ? _c("v-select", {
                        attrs: {
                          label: "Nature *",
                          items: _vm.categoriesItems,
                          outlined: "",
                          dense: "",
                          rules: [
                            nature =>
                              !!nature || "Vous devez choisir une nature."
                          ]
                        },
                        model: {
                          value: _vm.nature,
                          callback: function($$v) {
                            _vm.nature = $$v
                          },
                          expression: "nature"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-checkbox", {
                    staticClass: "mx-4",
                    attrs: { label: "Visible Extranet", color: "success" },
                    model: {
                      value: _vm.visible,
                      callback: function($$v) {
                        _vm.visible = $$v
                      },
                      expression: "visible"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-file-input", {
                attrs: {
                  label: "Fichier *",
                  rules: [file => !!file || "Vous devez choisir un fichier."]
                },
                model: {
                  value: _vm.file,
                  callback: function($$v) {
                    _vm.file = $$v
                  },
                  expression: "file"
                }
              }),
              _vm._v(" "),
              _c("v-textarea", {
                attrs: { outlined: "", label: "Commentaire" },
                model: {
                  value: _vm.comment,
                  callback: function($$v) {
                    _vm.comment = $$v
                  },
                  expression: "comment"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }